var React = require('react');

function Tablet (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7 3.5C7 3.22386 7.22386 3 7.5 3H8.5C8.77614 3 9 3.22386 9 3.5C9 3.77614 8.77614 4 8.5 4H7.5C7.22386 4 7 3.77614 7 3.5Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 1.5C2 1.22386 2.22386 1 2.5 1H13.5C13.7761 1 14 1.22386 14 1.5V12H2V1.5ZM1 12.5V1.5C1 0.671573 1.67157 0 2.5 0H13.5C14.3284 0 15 0.671573 15 1.5V12.5V14.5C15 15.3284 14.3284 16 13.5 16H2.5C1.67157 16 1 15.3284 1 14.5V12.5ZM14 13V14.5C14 14.7761 13.7761 15 13.5 15H2.5C2.22386 15 2 14.7761 2 14.5V13H14Z","key":1})]);
}

Tablet.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Tablet;

Tablet.default = Tablet;
